var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPassword = function SvgIcPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 13.2a1.788 1.788 0 0 0-1.2 3.132V18a1.2 1.2 0 1 0 2.4 0v-1.668A1.787 1.787 0 0 0 9.6 13.2Zm6-4.8V6a6 6 0 1 0-12 0v2.4A3.6 3.6 0 0 0 0 12v8.4A3.6 3.6 0 0 0 3.6 24h12a3.6 3.6 0 0 0 3.6-3.6V12a3.6 3.6 0 0 0-3.6-3.6ZM6 6a3.6 3.6 0 1 1 7.2 0v2.4H6V6Zm10.8 14.4a1.2 1.2 0 0 1-1.2 1.2h-12a1.2 1.2 0 0 1-1.2-1.2V12a1.2 1.2 0 0 1 1.2-1.2h12a1.2 1.2 0 0 1 1.2 1.2v8.4Z"
  })));
};
export default SvgIcPassword;